import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Toast,
  Spinner,
  Button,
  PageActions,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import moment from "moment";
import { capitalizeFirstLetter } from "../../Helpers";

const SubscriptionDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [result, setResult] = useState("");
  const [ts, setTs] = useState("");

  useEffect(() => {
    fetchData();
  }, [ts]);
  async function fetchData() {
    let responseItem = "";
    try {
      responseItem = await axios.get(`/subscriptions/${id}`);
      setResult(responseItem.data.data);
    } catch (error) {
      console.log(error);
    }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast content="" onDismiss={toggleActive} />
  ) : null;
  const parseName = (jsonObj) => {
    if (jsonObj?.submembership?.name) {
      return jsonObj.submembership.name;
    } else if (jsonObj?.subpackage?.name) {
      return jsonObj.subpackage.name;
    }
    return null;
  };
  const switchStatusColor = (param) => {
    switch (param) {
      case "pending":
        return `default`;
      case "confirmed":
        return `success`;
      case "cancelled":
        return `warning`;
      case "cancelled with charge":
        return `warning`;
      case "failed":
        return `critical`;
      default:
        return "";
    }
  };
  return result ? (
    <Page
      narrowWidth
      backAction={{ onAction: () => navigate("/admin/subscriptions") }}
      title={`${parseName(result)}`}
      titleMetadata={
        <Badge tone={switchStatusColor(result.status)}>
          {capitalizeFirstLetter(result?.status)}
        </Badge>
      }
    >
      <FormLayout>
        <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              USER DETAILS
            </Text>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>First Name</b>
                <br />
                {result?.user && result?.user?.first_name
                  ? result?.user?.first_name
                  : "-"}
              </Text>
              <Text breakWord>
                <b>Last Name</b>
                <br />
                {result?.user && result?.user?.last_name
                  ? result?.user?.last_name
                  : "-"}
              </Text>
              <Text breakWord>
                <b>Created at</b>
                <br />
                {result?.created_at
                  ? moment(result?.created_at).format("YYYY-MM-DD HH:mm:ss")
                  : "-"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Email</b>
                <br />
                {result?.user && result?.user?.email
                  ? result?.user?.email
                  : "-"}
              </Text>
              <Text breakWord>
                <b>Nationality</b>
                <br />
                {result?.user && result?.user?.nationality
                  ? result?.user?.nationality
                  : "-"}
              </Text>
              <Text></Text>
            </FormLayout.Group>

            <Text variant="headingSm" as="h6">
              SUBSCRIPTION DETAILS
            </Text>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Type</b>
                <br />
                {result?.type ? result?.type : "-"}
              </Text>
              <Text breakWord>
                <b>Subpackage/Submembership</b>
                <br />
                {parseName(result)}
              </Text>
              <Text breakWord>
                <b>Amount</b>
                <br />
                {result?.amount !== null ? result?.amount : "-"}
              </Text>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Status</b>
                <br />
                {result?.status !== null ? result?.status : "-"}
              </Text>
              <Text breakWord>
                <b>Start Date</b>
                <br />
                {result?.start_date
                  ? moment(result?.start_date).format("YYYY-MM-DD HH:mm:ss")
                  : "-"}
              </Text>
              <Text breakWord>
                <b>Expiry Date</b>
                <br />
                {result?.expiry_date
                  ? moment(result?.expiry_date).format("YYYY-MM-DD HH:mm:ss")
                  : "-"}
              </Text>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Payment Method</b>
                <br />
                {result?.payment_type
                  ? capitalizeFirstLetter(result?.payment_type)
                  : "-"}
              </Text>
              <Text breakWord></Text>
              <Text breakWord></Text>
            </FormLayout.Group>
          </FormLayout>
        </Card>
      </FormLayout>

      {toastMarkup}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
};

export default SubscriptionDetails;
